import * as React from 'react'
import { TabbedCard } from '../tabbed-card'
import { ProposalImpact } from './ProposalImpact'
import { ProposalSkills } from './ProposalSkills'
import { ProposalPreserve } from './ProposalPreserve'
import { ProposalGrow } from './ProposalGrow'
import { ProposalTransition } from './ProposalTransition'
import { Team } from '../types'

export type AnalysisCardProps = {
  id: number
  teams: Team[]
  title: string
  onAnchorClick?: () => void
  onClose?: () => void
  dragHandleProps?: React.HTMLAttributes<HTMLButtonElement>
  style?: React.CSSProperties
}

// eslint-disable-next-line react/display-name
export const AnalysisCard = React.forwardRef<HTMLElement, AnalysisCardProps>(
  (
    { id, teams, title, onAnchorClick, onClose, dragHandleProps, style },
    ref
  ) => {
    const [collapsed, setCollapsed] = React.useState(false)
    const [selectedTeam, setSelectedTeam] = React.useState<number | null>(null)

    const teamsWithSelection = teams.map((team) => ({
      ...team,
      selected: team.id === selectedTeam,
    }))

    return (
      <TabbedCard
        ref={ref}
        draggable
        dragHandleProps={dragHandleProps}
        collapsed={collapsed}
        onAnchorClick={onAnchorClick}
        onToggleCollapsed={() => setCollapsed((c) => !c)}
        onTeamSelect={(id) => setSelectedTeam(id)}
        onClose={onClose}
        selectedTeam={selectedTeam}
        style={style}
        /* eslint-disable react/jsx-key */
        tabs={[
          [
            'Impact',
            <ProposalImpact
              id={id}
              onSelect={setSelectedTeam}
              selectedTeam={selectedTeam}
              teams={teamsWithSelection}
            />,
          ],
          [
            'Skills',
            <ProposalSkills
              id={id}
              selectedTeam={selectedTeam}
              teams={teamsWithSelection}
            />,
          ],
          ['Preserve', <ProposalPreserve id={id} />],
          ['Grow', <ProposalGrow id={id} />],
          ['Transition', <ProposalTransition id={id} />],
        ]}
        /* eslint-enable react/jsx-key */
        teams={teamsWithSelection}
        title={title}
      />
    )
  }
)
